/**
 * KiAssistantTab — the side-panel KI-Hofassistent chat tab (issue #1656).
 *
 * Since FR-015 the full conversation implementation (budget badge, async-202
 * turn lifecycle, thinking indicator + live steps, failed-turn retry rows,
 * clear-conversation, cited-document deep-links) lives in the shared
 * ``AssistantConversation`` — this tab is the panel surface over it, bound to
 * the user's MOST RECENTLY ACTIVE conversation (``/chat/threads`` is ordered
 * ``last_message_at DESC``, so the first ``agent_assistant`` row is it). The
 * /agent workspace page renders the same component per selected conversation;
 * a first-ever turn here posts without a ``thread_id`` and the backend
 * resolves/creates the conversation server-side.
 */
import React, { useMemo } from 'react';
import { useChatThreads } from '../../../hooks/useChatQueries';
import { AssistantConversation } from '../AssistantConversation';

export const KiAssistantTab: React.FC = () => {
  const threadsQuery = useChatThreads();
  const thread = useMemo(
    () => threadsQuery.data?.find((tr) => tr.thread_kind === 'agent_assistant'),
    [threadsQuery.data],
  );
  return <AssistantConversation thread={thread} />;
};
